var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout reference-uniform-items" },
    [
      _c("m-table-settings", {
        ref: "columnSettings",
        attrs: { columns: _vm.columns },
        on: { apply: _vm.submitTableSettings },
      }),
      _c("item-sidesheet", {
        ref: "itemModal",
        attrs: { "can-remove": _vm.canRemove },
        on: {
          updated: _vm.updateItemData,
          created: _vm.updateList,
          remove: _vm.updateList,
        },
      }),
      _c("item-history-sidesheet", { ref: "itemHistoryModal" }),
      _c("m-issue-item", {
        ref: "issueItem",
        on: { issued: _vm.updateItemStatus },
      }),
      _c("m-withdraw-item", {
        ref: "withdrawItem",
        on: { withdrawn: _vm.updateItemStatus },
      }),
      _c("m-write-off-item", {
        ref: "writeOffItem",
        on: { writtenOff: _vm.updateItemStatus },
      }),
      _c("m-remove-item", {
        ref: "removeItem",
        on: { remove: _vm.updateList },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [
          _vm._v("Каталог товарно-материальных ценностей"),
        ]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button2", {
                attrs: {
                  size: "small",
                  label: "Структура каталога",
                  icon: {
                    icon: "back",
                    color: "blue",
                  },
                  responsive: true,
                },
                on: { click: _vm.toCatalog },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button", {
                attrs: {
                  icon: {
                    icon: "google",
                    color: "green",
                  },
                  size: "small",
                  label: "Выгрузить в Google таблицы",
                  responsive: "",
                },
                on: { click: _vm.toGoogle },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button", {
                attrs: {
                  responsive: "",
                  label: "Новая ТМЦ",
                  icon: {
                    icon: "plus",
                    color: "white",
                  },
                  color: "blue",
                },
                on: { click: _vm.addItem },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "layout-content" },
        [
          !_vm.inited
            ? _c("c-loader", {
                attrs: {
                  active: !_vm.inited,
                  label: "Данные загружаются",
                  height: 450,
                },
              })
            : [
                _c("filters", {
                  attrs: { filters: _vm.filters.fields },
                  on: { apply: _vm.applyFilters },
                }),
                _c(
                  "div",
                  { staticClass: "meta-filters" },
                  [
                    _c("stats", {
                      staticClass: "stats",
                      attrs: {
                        total: _vm.stats.totalData,
                        filtered: _vm.stats.filteredData,
                        loading: _vm.loading,
                      },
                    }),
                    _c("div", { staticClass: "configure-table" }, [
                      _c(
                        "div",
                        { staticClass: "configure-table__wrapper" },
                        [
                          _c("c-button2", {
                            attrs: {
                              responsive: true,
                              icon: { icon: "filter-drop", color: "secondary" },
                              label: "Сбросить фильтры столбцов",
                              size: "small",
                              disabled: !_vm.hasTableFilters,
                            },
                            on: { click: _vm.resetTableFilters },
                          }),
                          _c("c-button2", {
                            attrs: {
                              responsive: true,
                              size: "small",
                              label: "Настроить столбцы",
                              icon: "cog",
                              type: "with-icon",
                            },
                            on: { click: _vm.openColumnSettingsModal },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c("items-table", {
                  attrs: {
                    items: _vm.items.list,
                    filters: _vm.table.filters,
                    "sort-by": _vm.table.sortBy,
                    loading: _vm.loading,
                    columns: _vm.columns,
                    "user-columns": _vm.userColumns,
                    page: _vm.table.page,
                    "can-remove": _vm.canRemove,
                  },
                  on: {
                    sort: _vm.sort,
                    filter: _vm.applyTableFilters,
                    nextPage: _vm.nextPage,
                    edit: _vm.editItem,
                    issue: _vm.issueItem,
                    withdraw: _vm.withdrawItem,
                    writeOff: _vm.writeOffItem,
                    restore: _vm.restoreItem,
                    remove: _vm.removeItem,
                    showHistory: _vm.showItemHistory,
                  },
                }),
              ],
        ],
        2
      ),
      _c("top-button", { attrs: { root: ".layout" } }),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          !_vm.loading
            ? _c("show-items", {
                attrs: { count: _vm.items.list.length, total: _vm.totalCount },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }